export default {
  realPay: '应付：',
  loginTitle: '您登录即同意用户服务协议和隐私政策',

  nav: {
    home: "首页",
    services: "服务",
    about: "关于我们",
    help: "帮助",
    myBooking: "我的预定",
    login: "登录",
    register: "注册",
    logoutConfirm: "您确定要退出吗?",
    logTip: "提示",
    ok: "确认",
    cancel: "取消",
  },
  busconfirm: {
    phone: '联系电话',
    /*    contactInformation: 'Contact Information is required',
    userName: 'User Name is required', */
    contactInformation: '邮箱是必填项',
    userName: '用户名是必填项',
    amoutSmall: '金额不能小于1元',
    orderInfo: '预订信息',
    passengers: '{adult}成人{child}儿童',
    bookingInfo: '预定人信息',
    name: '姓名',
    contact: '联系邮箱',
    payment: '确认付款',
    paymentTime0: '请于',
    paymentTime1: '内完成付款',
    terms: '使用条款',
    policy: '退订政策',
    paymentBtn: '前往支付',
    srxm: '请输入姓名',
    srlx: '请输入联系方式',
    fhsyy: '返回上一页',
  },
  footer: {
    company: {
      title: '公司',
      media: '我们如何工作',
      environmental: '可持续出行',
      partner: '成为代驾伙伴'
    },
    aboutUs: {
      title: '关于我们',
      overview: '概述',
      travelAgency: '成为我们的伙伴',
      partnership: '战略伙伴关系',
      description: "LanePlus专注于包车游、机场接送与旅行用车，为全球旅客提供高效、安全、个性化的出行体验。",

    },
    aboutUs0: {
      title: '我们如何工作',
      overview: '概述',
      travelAgency: '成为我们的伙伴',
      partnership: '战略伙伴关系',
      description: "LanePlus专注于包车游、机场接送与旅行用车，为全球旅客提供高效、安全、个性化的出行体验。",

    },
    aboutUs1: {
      title: '可持续出行',
      description: '可持续出行',
    },
    subTitle4_7: `可持续出行
LanePlus致力于通过技术创新推动可持续出行，为全球旅客提供绿色、高效的长途用车选择。我们积极倡导并优先推荐电动车（EV）服务，以减少碳排放，降低环境足迹。

通过与本地服务商合作推广新能源车队，我们希望将环保理念融入每一次旅程，为实现零排放未来贡献力量。

选择LanePlus，不仅是一次便捷的长途旅行，更是迈向绿色未来的一步。让我们用技术连接世界，同时守护我们的地球。
`,
    aboutUs2: {
      title: '概述',
      overview: 'LanePlus —— 重新定义您的每一次出行',
      description: `LanePlus专注于包车游、机场接送与旅行用车，为全球旅客提供高效、安全、个性化的出行体验。我们结合先进科技与本地服务，通过智能匹配系统和简洁直观的预订流程，让您的出行更便捷、更高效。`
    },
    subTitle4_8: `为什么选择 LanePlus？</br>
        <li>●便捷预订：几步即可完成预订，操作简单、快速。</li>
        <li>●安全支付：支持多种支付方式，保障您的交易安全无忧。</li>
        <li>●多样选择：从经济型到豪华商务车，满足不同需求和预算。</li>
        <li>●安心出行：专业筛选与培训的司机为您提供安全可靠的服务。无论是跨城旅行、度假包车，还是机场接送，LanePlus都致力于让您的旅程更轻松自由。LanePlus，重新定义您的每一次出行。</li>
`,
    aboutUs3: {
      title: '机场接送机',
      overview: '服务类型',
      description: ``
    },
    subTitle4_9: `<div style="padding: 20px;">
    <section>
      <h2 style="font-size: 1.5em; margin-bottom: 10px;">服务简介</h2>
      <p>LanePlus 提供覆盖澳洲、新西兰及亚洲主要城市的机场接送服务。无论是从机场到酒店，还是从家到机场，我们的专业司机都会为您提供准时、安全的接送服务，让您的旅途顺畅无忧。</p>
    </section>

    <section style="margin: 20px 0;">
      <h3 style="font-size: 1.2em;">服务亮点</h3>
      <ul style="list-style-type: none; padding: 0;">
        <li>●准时无误：实时航班追踪，确保司机准时到达，即使航班延误也无需担心。</li>
        <li>●多样车型选择：提供从经济型车辆到豪华商务车的多种选择，满足不同旅客需求。</li>
        <li>●门到门服务：从接机到送达，全程舒适贴心。</li>
        <li>●透明定价：无隐藏费用，预订时即可确认总价。</li>
      </ul>
    </section>

    <section style="margin: 20px 0;">
      <h3 style="font-size: 1.2em;">适用场景</h3>
      <ul style="list-style-type: none; padding: 0;">
        <li>●商务出行</li>
        <li>●家庭或团体旅行</li>
        <li>●凌晨或深夜航班接送</li>
      </ul>
    </section>

    <p>立即预订，让您的旅程从机场开始就更加轻松！</p>
  </div>
`,
    aboutUs4: {
      title: '旅行包车',
      overview: '服务简介',
      description: `LanePlus 为您提供灵活、高效的旅行包车服务，无论是一日游、多日游还是跨城市长途旅行，我们都能根据您的需求定制行程，让您以最舒适的方式探索目的地。`
    },
    subTitle4_10: `<div style="padding: 20px;">
  <section>
    <h2 style="font-size: 1.5em; margin-bottom: 10px;">服务亮点</h2>
    <ul style="list-style-type: none; padding: 0;">
      <li>● 灵活行程：根据您的需求自由规划路线，尽享旅途乐趣。</li>
      <li>● 专业司机：经验丰富的本地司机不仅熟悉路线，还能为您提供旅行建议。</li>
      <li>● 多样车型选择：从舒适的家庭座驾到豪华商务车，满足不同团队规模和需求。</li>
      <li>● 高性价比：按天或按行程收费，无需担心额外费用。</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">推荐路线</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● 澳洲：大洋路一日游、蓝山国家公园游览</li>
      <li>● 新西兰：霍比特村之旅、皇后镇周边探索</li>
      <li>● 亚洲：定制行程探索当地文化与自然景点</li>
    </ul>
  </section>

  <p>立即联系我们，开始您的专属旅行之旅！</p>
</div>

`,
    aboutUs5: {
      title: '成为我们的伙伴',
      overview: '加入 LanePlus 成为我们的合作伙伴',
      description: `在 LanePlus，我们致力于通过专业、可靠的合作伙伴，为用户提供卓越的出行体验。无论您是企业还是个体司机，加入我们的平台意味着您将成为可信赖的运输服务网络的一员，与我们一起为旅行者提供优质服务。`
    },
    subTitle4_11: `<div style="padding: 20px;">
  <section>
    <h2 style="font-size: 1.5em; margin-bottom: 10px;">资格要求</h2>
    <h3 style="font-size: 1.2em;">企业合作伙伴</h3>
    <p>若您是企业，需满足以下条件：</p>
    <ul style="list-style-type: none; padding: 0;">
      <li>● 持有相关交通管理机构颁发的 预订服务提供商（BSP）资格。</li>
      <li>● 确保所有车辆及司机符合当地客运服务的监管要求。</li>
    </ul>

    <h3 style="font-size: 1.2em;">个体合作伙伴</h3>
    <p>若您是个体司机，需满足以下条件：</p>
    <ul style="list-style-type: none; padding: 0;">
      <li>● 您的车辆必须注册为 商业客运车辆（CPV）。</li>
      <li>● 持有相关交通管理机构颁发的有效 司机资格认证（Driver Accreditation）。</li>
      <li>● 保持车辆清洁整洁，为乘客提供最佳体验。</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">为什么选择与 LanePlus 合作？</h3>
    <ul style="list-style-type: none; padding: 0;">
      <li>● 扩大您的客户群：接触越来越多的旅行者，满足他们的出行需求。</li>
      <li>● 灵活的合作机会：自由安排时间，使用我们用户友好的平台。</li>
      <li>● 支持与培训：获得我们团队的支持和资源，助您成功开展业务。</li>
    </ul>
  </section>

  <section style="margin: 20px 0;">
    <h3 style="font-size: 1.2em;">如何申请</h3>
    <ol style="padding: 0;">
      <li>通过邮箱联系我们：发送邮件至 <a href="mailto:support.laneplus.com.au" style="color: #007bff;">support.laneplus.com.au</a> ，表达您希望成为 LanePlus 合作伙伴的意愿。</li>
      <li>提供相关文件：收到您的咨询后，我们的团队将指导您完成申请流程，并要求您提供必要的文件，例如企业的 BSP 资格认证，或个体司机的 CPV 注册和司机资格认证。</li>
      <li>资质审核：我们将仔细审核并验证您的资质，确认合作资格。</li>
    </ol>
  </section>
</div>

`,
    "melbourne": {
      "title": "墨尔本",
      "overview": "Melbourne",
      "description": "墨尔本是澳大利亚的文化和体育之都，以其充满活力的艺术氛围、巷道咖啡馆和动感生活方式而闻名。在这座城市里，现代摩天大楼与维多利亚风格的建筑和谐共存，全年都有各类节庆和活动点缀其中。",
      "recommendedActivities": "<h3 style='font-size: 24px; font-weight: bold; color: #333;'>推荐活动</h3><ul style='list-style-type: none; padding-left: 0;'><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>大洋路一日游：</strong><span style='font-size: 16px; color: #555;'>体验风景如画的海岸公路，参观十二使徒岩，探索奥特韦雨林的自然奇观。</span></li><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>菲利普岛企鹅归巢：</strong><span style='font-size: 16px; color: #555;'>观赏企鹅每晚回巢的可爱景象，适合全家一起体验。</span></li><li><strong style='font-size: 18px; color: #0056b3;'>亚拉河谷酒庄品酒：</strong><span style='font-size: 16px; color: #555;'>品尝优质葡萄酒和美食，享受澳大利亚著名的葡萄酒产区的魅力。</span></li></ul>"
    },
    "sydney": {
      "title": "悉尼",
      "overview": "Sydney",
      "description": "悉尼作为澳大利亚的核心城市，以其标志性的地标建筑、美丽的海滩和迷人的港湾而著称。这座城市完美融合了都市的时尚与自然的壮丽风光，是旅行者的热门目的地。",
      "recommendedActivities": "<h3 style='font-size: 24px; font-weight: bold; color: #333;'>推荐活动</h3><ul style='list-style-type: none; padding-left: 0;'><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>蓝山国家公园一日游：</strong><span style='font-size: 16px; color: #555;'>探索陡峭的悬崖、瀑布和桉树林，这里是联合国教科文组织的世界遗产地。</span></li><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>邦迪到库吉海岸步道：</strong><span style='font-size: 16px; color: #555;'>沿着这条风景优美的步道漫步，欣赏悉尼最著名海滩的壮丽海景。</span></li><li><strong style='font-size: 18px; color: #0056b3;'>猎人谷酒庄游：</strong><span style='font-size: 16px; color: #555;'>在澳大利亚最古老的葡萄酒产区品尝顶级葡萄酒、奶酪和巧克力。</span></li></ul>"
    },
    "adelaide": {
      "title": "阿德莱德",
      "overview": "Adelaide",
      "description": "阿德莱德是一座迷人的城市，以其悠闲的生活方式、热闹的节庆活动和世界一流的葡萄酒产区而闻名。周边风景优美，是探索南澳大利亚多样自然奇观的门户。",
      "recommendedActivities": "<h3 style='font-size: 24px; font-weight: bold; color: #333;'>推荐活动</h3><ul style='list-style-type: none; padding-left: 0;'><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>巴罗萨谷酒庄游：</strong><span style='font-size: 16px; color: #555;'>在澳大利亚最著名的葡萄酒产区品尝世界顶级的葡萄酒。</span></li><li style='margin-bottom: 15px;'><strong style='font-size: 18px; color: #0056b3;'>袋鼠岛一日游：</strong><span style='font-size: 16px; color: #555;'>在这片自然爱好者的天堂中邂逅独特的野生动物和原始海滩。</span></li><li><strong style='font-size: 18px; color: #0056b3;'>阿德莱德山与汉多夫德国村游览：</strong><span style='font-size: 16px; color: #555;'>漫步于风景如画的山丘，探索澳大利亚最古老的德国小镇的魅力。</span></li></ul>"
    },
    aboutUs6: {
      title: '墨尔本',
      overview: ' Melbourne',
      description: `墨尔本是澳大利亚的文化和体育之都，以其充满活力的艺术氛围、巷道咖啡馆和动感生活方式而闻名。在这座城市里，现代摩天大楼与维多利亚风格的建筑和谐共存，全年都有各类节庆和活动点缀其中。`
    },
    subTitle4_12: `
●推荐活动：
●大洋路一日游：体验风景如画的海岸公路，参观十二使徒岩，探索奥特韦雨林的自然奇观。
●菲利普岛企鹅归巢：观赏企鹅每晚回巢的可爱景象，适合全家一起体验。
●亚拉河谷酒庄品酒：品尝优质葡萄酒和美食，享受澳大利亚著名的葡萄酒产区的魅力。

悉尼 Sydney
悉尼作为澳大利亚的核心城市，以其标志性的地标建筑、美丽的海滩和迷人的港湾而著称。这座城市完美融合了都市的时尚与自然的壮丽风光，是旅行者的热门目的地。
●推荐活动：
●蓝山国家公园一日游：探索陡峭的悬崖、瀑布和桉树林，这里是联合国教科文组织的世界遗产地。
●邦迪到库吉海岸步道：沿着这条风景优美的步道漫步，欣赏悉尼最著名海滩的壮丽海景。
●猎人谷酒庄游：在澳大利亚最古老的葡萄酒产区品尝顶级葡萄酒、奶酪和巧克力。

阿德莱德 Adelaide
阿德莱德是一座迷人的城市，以其悠闲的生活方式、热闹的节庆活动和世界一流的葡萄酒产区而闻名。周边风景优美，是探索南澳大利亚多样自然奇观的门户。
●推荐活动：
●巴罗萨谷酒庄游：在澳大利亚最著名的葡萄酒产区品尝世界顶级的葡萄酒。
●袋鼠岛一日游：在这片自然爱好者的天堂中邂逅独特的野生动物和原始海滩。
●阿德莱德山与汉多夫德国村游览：漫步于风景如画的山丘，探索澳大利亚最古老的德国小镇的魅力。`,
    popularCities: {
      title: '探索热门城市',
      newYork: '墨尔本',
      london: '悉尼 ',
      berlin: '阿德莱德',
      la: '洛杉矶',
      paris: '巴黎',
      allCities: '所有城市'
    },
    serviceTypes: {
      title: '服务类型',
      longDistance: '长距离',
      luxuryCar: '高档轿车服务',
      exclusiveDriver: '机场接送服务',
      privateCharter: '旅游包车服务',
      busService: '客运汽车服务',
      airportTransfer: '机场接送服务',
      airportP: '接机服务',
      airportP0: '出发地'
    },
    contact: {
      title: '联系我们',
      email: '邮箱: ',
      phone: '邮箱 ',
      address: '地址：l51 George Street，Winchester，SO23 8BU'
    },
    copyright: {
      text: 'Copyright © 2024 LanBry',
      terms: '用户条款',
      termsUrl: 'https://www.laneplus.com.au/common/LanePlus%20%E7%94%A8%E6%88%B7%E6%9D%A1%E6%AC%BE%E5%92%8C%E6%9D%A1%E4%BB%B6.pdf',
      privacy: '隐私政策',
      privacyUrl: 'https://www.laneplus.com.au/common/LanePlus%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf',
      legal: '法律告示',
      accessibility: '可访问性'
    }
  },
  login: {
    tips1: "安全",
    tips2: "简单",
    tips3: "方便",
    title: '欢迎登录',
    account: '账号',
    password: '密码',
    forgotPassword: '忘记密码',
    loginBtn: '登录',
    register: '快速注册',
    agreement: '您登录即同意用户',
    serviceAgreement: '服务协议',
    privacyPolicy: '隐私政策',
    authAgreement: '授权许可协议',
    phoneLogin: '邮箱登录',
    passwordLogin: '密码登录',
    verificationCode: '验证码',
    getCode: '获取验证码',
    resendCode: '重新发送',
    phone: '邮箱',
  },
  register: {
    title: '欢迎注册',
    username: '用户名',
    phone: '邮箱',
    password: '密码',
    verificationCode: '验证码',
    getCode: '获取验证码',
    hasAccount: '已有账号？',
    goLogin: '去登录',
    registerBtn: '注册',
    repetSend: '重新发送',
  },
  airport: {
    pickup: '接机',
    dropoff: '送机',
    selectAirport: '选择机场',
    pickupAddress: '上车地址',
    dropoffAddress: '下车地址',
    dateTime: '日期时间',
    flightInfo: '航班信息',
    passengers: '乘客',
    luggage: '行李',
    children: '儿童（16岁及以下）',
    payComment: '点击“前往支付”，即表示您已核对预订订单及总金额，且同意《使用条款》和《退订政策》',
    carType: '车型',
    selectCar: '选择车型',
    book: '立即预定',
    waitingTime: '司机将免费等候15分钟',
    airportInfro: '请输入航班信息（航班号）',
    qijia: '起',
    adult: "成人及16岁以上",
    lc: '里程(公里)',
    zje: '总金额'
  },
  message: {
    required: {
      airport: '请选择机场',
      datetime: '请选择日期时间',
      dropoff: '请输入下车地址',
      pickup: '请输入上车地址',
      carType: '请选择车型'
    }
  },
  home: {
    titleTip: '包车游服务',
    subTitle: '接送机服务',
    subTitle2: '接机',
    subTitle3: '送机',
    heroTitle: '以您的方式探索澳大利亚',
    heroSubtitle: '私人接送、一日游及包车服务 — 直接预订，无中间商',
    browseTours: '浏览行程',
    viewDetails: '查看详情',
    alsoOn: '同步上架平台',
    whyTitle: '为什么选择 LanePlus？',
    badge: { private: '私人' },
    tag: { confirm: '立即确认', private: '私人包车' },
    trust1: '本地运营商',
    trust2: '安全预订',
    trust3: '中英文服务',
    service: { airport: '接送机服务', dayTour: '一日游', charter: '私人包车', cruise: '邮轮接送' },
    why1: { title: '本地运营商', desc: '扎根澳大利亚，熟悉每条路线。' },
    why2: { title: '直订价格优势', desc: '无平台手续费，直接预订更省钱。' },
    why3: { title: '中英双语服务', desc: '全程中英文支持，沟通无障碍。' },
    why4: { title: '灵活私人行程', desc: '自定义路线，完全按您的计划出行。' },
    why5: { title: '可靠的沟通', desc: '行程前后均可通过 WhatsApp 联系我们。' },
    why6: { title: '值得信赖', desc: '数百位旅客的真实好评。' },
  },
  services: {
    title: '我们的服务',
    subTitle1: '接送机服务',
    subTitle1_1: '有竞争力的价格',
    subTitle1_1_info: '我们提供实惠透明的价格，让您以最佳性价比享受高品质的服务。',
    subTitle1_2: '高度灵活性',
    subTitle1_2_info: '根据您的需求自由定制行程，并提供多种车型选择，满足您的旅行需求。',
    subTitle1_3: '用户第一',
    subTitle1_3_info: '我们的客服团队随时为您提供帮助，确保您拥有顺畅、无忧的体验。',
    subTitle1_4: '可持续性',
    subTitle1_4_info: '我们支持环保旅行，提供电动车选项，在舒适出行的同时帮助减少碳足迹。',

    subTitle2: "包车游服务",
    subTitle2_1: "为您打造便捷舒适的旅游",
    subTitle2_1_info:
      "我们的包车游致力于为您打造便捷舒适的旅行体验。以技术为驱动，我们简化预定流程，为您节省时间和精力，同时创造非凡价值。我们提供从5座到12座的多款车型，满足个人、家庭及团体的多样化需求。无论您计划私人包车、半日游、一日游或多人团体旅行，我们的个性化服务将每次旅程打造成集便利、创新与品质于一体的卓越体验。",
    subTitle2_2: "轻松无忧的旅行体验",
    subTitle2_2_info: "不必再为陌生路线或团体交通协调而烦恼。我们的专业服务为您处理一切细节，让您专注于享受旅程。",
    subTitle2_3: "安全可靠的支付方式",
    subTitle2_3_info: "我们采用可信的支付系统，全程保护您的信息安全。多种支付方式供您选择，轻松完成支付。",
    subTitle2_4: "量身定制的服务",
    subTitle2_4_info: "灵活性是我们服务的核心。根据您的喜好定制行程，包括目的地、时间安排和车型选择，为您带来真正个性化的体验。",

    subTitle3: '官网名称已服务1036位客户',
    subTitle4: '在线提交您的需求，我们将为您提供更专业的服务',
    subTitle4_1: '请输入您的姓名（必填）',
    subTitle4_2: '请输入您的联系方式',
    subTitle4_3: '请输入您的留言',
    subTitle4_4: '立即提交',
    subTitle4_5: 'LanePlus —— 您的智能出行平台，专注于包车游、机场接送与旅行用车，为全球旅客提供高效、安全、个性化的出行体验，重新定义旅行中的每一次出行。\n' +
      '\n' +
      '我们将先进科技与本地化服务相结合，通过智能匹配系统和简洁直观的预订流程，让您的出行变得更便捷、更高效。从舒适的家庭座驾到豪华商务用车，从机场接送到一日包车游，多样化的服务选择随时满足您的不同需求。\n' +
      '\n' +
      '为什么选择 LanePlus？\n' +
      '科技赋能\n' +
      '平台依托智能算法与大数据调度系统，提供精准、高效的车辆匹配服务。\n' +
      '便捷预订\n' +
      '简单几步即可完成预订，支持安全便捷的在线支付，让您的出行从一开始就轻松无忧。\n' +
      '更多选择\n' +
      '提供从经济型座驾到高端商务车等多种车型，满足不同预算与场景下的出行需求。\n' +
      '安心出行\n' +
      '所有合作司机均经过严格筛选与专业培训，为您提供安全可靠的服务体验。\n' +
      '\n' +
      '无论是跨城旅行、度假包车，还是机场接送，LanePlus 都致力于为您提供灵活多样的出行选择，让您的旅程更轻松自由，更具品质。\n' +
      '\n' +
      '科技驱动，服务至上 —— LanePlus，重新定义您的每一次出行。\n',
    subTitle4_6: `LanePlus通过技术平台连接全球旅客与澳洲、新西兰及亚洲的本地专业长途旅行用车服务提供商，让旅客轻松预订可靠的专车服务。我们不直接提供或管理用车服务，而是通过技术支持本地服务商，为他们创造更多商机，特别是在长途旅行领域。

我们的价格体系透明且灵活，基于车辆类型、行驶距离和时间等因素动态生成。旅客可以通过竞价模式选择最符合需求的长途旅行服务。我们的收益来源于为本地服务商提供技术支持，助力他们更好地服务国际旅客。

LanePlus致力于结合区域特色与全球化预订体验，为长途旅行打造便捷、高效的用车解决方案`,

  },
  help: {
    title: "您好，我们有什么可以帮助您吗？",
    subTitle1: "常见问题",
  },
  order: {
    payPrice: "应付金额",
    Details: "查看详情",
    pay_item: '货币类型',
    pay_item0: '邮箱',
    pay_item1: '银行卡信息',
    pay_item2: '关闭',
    pay_item3: '请选择',
    pay_item4: '已完成',
    pay_item5: '待支付',
    pay_create_time: '订单创建时间',
    pay_item6: '已支付',
    pay_item7: '已取消',
    pay_item8: '退款',
    pay_item9: '立即付款',
    pay_item10: '您的订单已取消，期待下次见！',
    pay_item11: '您的订单已完成服务，期待下次见',
    pay_item12: '您的订单已支付完成  正在安排司机 请耐心等待',
    pay_item13: '您的订单还未支付  剩余',
    pay_item14: '机场',
    pay_item15: '实付款',
    pay_item16: '支付方式',
    pay_item17: '支付时间',
    pay_item18: '预订人信息',
    pay_item19: '前往支付',
    pay_item20: '应付',
    pay_item21: '确认付款',
    pay_item22: '请于',
    pay_item23: '内完成付款',
    pay_item24: '请先登录',
    pay_item25: '获取验证码',
    pay_item26: '重新发送',
    pay_item27: '请输入邮箱',
    pay_item28: '验证码发送成功',
    pay_item29: '登录成功',
    pay_item30: '请输入验证码',
    pay_item31: '邮箱格式不正确',
    pay_item32: '目的地错误，请重新选择目的地',
    pay_item33: '请输入正确的邮箱',
    pay_item34: '请选择货币类型',
  }


} 
